import React from 'react';
import { Button, Space } from 'antd';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch } from '../../../../../store';
import { clearSelection } from '../../../../common/store/selectionSlice';

export const PromocodeCreateButton = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const createPromocode = () => {
        dispatch(clearSelection());
        navigate('create');
    };

    return (
        <Space>
            <Button onClick={createPromocode} type={'primary'}>
                Создать промокод
            </Button>
        </Space>
    );
};
